module.exports = __webpack_public_path__ + "img/zapier.03b6c16a.png";